import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'

function InputColor (props) {

  const manager = usePortManager()

  const item_id = props.name + props.value
  const checked = manager.getValue(props.name) === props.value

  const hex = require('ral-to-hex')

  const update = function (key, value) {
    manager.updateValue(key, value)
    manager.removeValue('custom_' + key)
  }

  return (
    <aside className={'input input-color'} data-color={props.ral}>
      <input id={item_id} type={'radio'} name={props.name} value={props.value} checked={checked}
             onChange={() => update(props.name, props.value)}/>
      <label htmlFor={item_id} style={{ backgroundColor: hex(props.ral) }} title={props.strings.title}>

      </label>
    </aside>
  )
}

export default observer(InputColor)